import {
  Alert02Icon,
  ArrowDown01Icon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  ArrowUp01Icon,
  Calendar03Icon,
  Cancel01Icon,
  ChartHistogramIcon,
  CheckmarkCircle02Icon,
  Clock01Icon,
  CloudSavingDone01Icon,
  CloudUploadIcon,
  Download04Icon,
  Edit02Icon,
  InformationCircleIcon,
  Logout03Icon,
  MoreHorizontalIcon,
  PlusSignIcon,
  RefreshIcon,
  Search01Icon,
  SquareLock02Icon,
  Tick02Icon,
  UserCircleIcon,
  UserGroupIcon,
  ViewIcon,
  ViewOffIcon,
  WifiOff01Icon,
} from '@hugeicons/core-free-icons'
import { HugeiconsIcon, type IconSvgElement } from '@hugeicons/react'

/**
 * The icon registry, the only door an icon comes through (pwa_starter rule 1).
 * Keys name the meaning, not the picture. One set, three sizes (16/20/24),
 * thin outlined strokes (1.5; 2 for the active tab), always currentColor —
 * black on white, white on black (Minimalist Monochrome).
 */
export const ICON_REGISTRY = {
  meetings: Calendar03Icon,
  summary: ChartHistogramIcon,
  account: UserCircleIcon,
  members: UserGroupIcon,
  back: ArrowLeft01Icon,
  forward: ArrowRight01Icon,
  up: ArrowUp01Icon,
  down: ArrowDown01Icon,
  add: PlusSignIcon,
  edit: Edit02Icon,
  check: Tick02Icon,
  done: CheckmarkCircle02Icon,
  close: Cancel01Icon,
  search: Search01Icon,
  alert: Alert02Icon,
  info: InformationCircleIcon,
  offline: WifiOff01Icon,
  sending: CloudUploadIcon,
  saved: CloudSavingDone01Icon,
  retry: RefreshIcon,
  logout: Logout03Icon,
  lock: SquareLock02Icon,
  show: ViewIcon,
  hide: ViewOffIcon,
  time: Clock01Icon,
  more: MoreHorizontalIcon,
  install: Download04Icon,
} satisfies Record<string, IconSvgElement>

export type IconName = keyof typeof ICON_REGISTRY

export function AppIcon({
  name,
  size = 20,
  color,
  strokeWidth = 1.5,
  className,
}: {
  name: IconName
  size?: 16 | 20 | 24
  color?: string
  strokeWidth?: number
  className?: string
}) {
  return (
    <HugeiconsIcon
      icon={ICON_REGISTRY[name]}
      size={size}
      color={color ?? 'currentColor'}
      strokeWidth={strokeWidth}
      className={className}
      aria-hidden="true"
    />
  )
}
